import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AppSelectComponent } from './app-select.component';
import { AppSelectSearchInputComponent } from './app-select-search-input/app-select-search-input.component';
import { SelectedOptionDirective, SelectOptionDirective } from './select-option.directive';
import { ClickZonelessModule } from '@core/directives/zoneless/click/click-zoneless.module';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { PushModule } from '@rx-angular/template/push';
import { AutofocusModule } from '@ui-kit/directives/autofocus/autofocus.module';
import { OutsideClickModule } from '@ui-kit/directives/outside-click/outside-click.module';
import { LoaderModule } from '@ui-kit/loader/loader.module';

@NgModule({
  declarations: [AppSelectComponent, AppSelectSearchInputComponent, SelectOptionDirective, SelectedOptionDirective],
  imports: [
    CommonModule,
    ScrollingModule,
    OutsideClickModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    LoaderModule,
    FormsModule,
    AutofocusModule,
    TranslateUiModule,
    PushModule,
    ClickZonelessModule
  ],
  exports: [AppSelectComponent, SelectOptionDirective, SelectedOptionDirective]
})
export class AppSelectModule {}
